function initial(value) {
  if (value) {
    if (/Guest [0-9]/.test(value)) {
      return value.replace('Guest ', '');
    }

    return value.substr(0, 1).toUpperCase();
  }

  return null;
}



export default initial;
